import { adminActionTypes } from "src/action_types/section_action_types";

export function rulesSelectedFacilityReducer(state = "", action) {
  switch (action.type) {
    case adminActionTypes.selectRulesFacility:
      return action.payload;
    default:
      return state;
  }
}
